"use client";

import { type VersionInfo } from "@/api/home";
import { create } from "zustand";

interface AppVersionState {
    showVersionPopup: boolean;
    versionInfo: VersionInfo | null;
    versionCheckFinished: boolean;
    setShowVersionPopup: ( show: boolean ) => void;
    setVersionInfo: ( info: VersionInfo | null ) => void;
    setVersionCheckFinished: ( finished: boolean ) => void;
}

export const useAppVersionStore = create<AppVersionState>()( ( set ) => ( {
    showVersionPopup: false,
    versionInfo: null,
    versionCheckFinished: false,
    setShowVersionPopup: ( show ) => set( { showVersionPopup: show } ),
    setVersionInfo: ( info ) => set( { versionInfo: info } ),
    setVersionCheckFinished: ( finished ) => set( { versionCheckFinished: finished } ),
} ) );
